import React from 'react';
import './PrintDocument.css';

const PrintReport = ({ data, shop }) => {
  if (!data || !shop) return null;

  const { title, dateRange, headers, rows, summary } = data;
  const shopName = shop?.shop_name || 'Shop';

  return (
    <div className="print-document-wrapper print-only">
      <style type="text/css" media="print">
        {`@page { size: A4 landscape; margin: 10mm !important; }`}
      </style>

      <div className="print-document-container size-a4-landscape">
        <div className="print-header">
          {shop?.shop_logo && (
            <div className="logo-container">
              <img src={shop.shop_logo} alt="Logo" className="shop-logo" />
            </div>
          )}
          <div className={shop?.shop_logo ? 'shop-details-right' : 'shop-details-center'}>
            <h1 className="shop-name">{shopName}</h1>
            <div className="shop-details">
              {(shop?.address || shop?.location) && <div>{shop?.address || shop?.location}</div>}
              {(shop?.mobile_no || shop?.phone) && <div>Phone: {shop?.mobile_no || shop?.phone}</div>}
              {shop?.trn_number && <div>GSTIN: {shop.trn_number}</div>}
            </div>
          </div>
        </div>

        <div className="thick-divider"></div>
        <div className="title-section">
          <h2 className="document-title">{title}</h2>
          {dateRange && <div className="report-date-range">{dateRange}</div>}
        </div>
        <div className="thick-divider"></div>

        <div className="report-body">
          <table className="items-table report-table">
            <thead>
              <tr>
                <th className="col-index">SN</th>
                {headers.map((header, idx) => (
                  <th key={idx} className={header.className}>
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  <td className="text-center">{rowIdx + 1}</td>
                  {headers.map((header, colIdx) => (
                    <td key={colIdx} className={header.className || ''}>
                      {row[header.id] !== undefined ? row[header.id] : ''}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {summary && Object.keys(summary).length > 0 && (
            <div className="report-summary-section">
              <table className="summary-table report-summary-table no-page-break">
                <tbody>
                  {Object.entries(summary).map(([label, value], idx) => (
                    <tr key={idx}>
                      <td className="summary-label-cell">{label}</td>
                      <td className="summary-value-cell">{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="page-footer-info mt-4">
          <div style={{ flex: 1 }}>Printed on: {new Date().toLocaleString()}</div>
          <div style={{ flex: 1, textAlign: 'center' }}>sanoft.com</div>
          <div style={{ flex: 1, textAlign: 'right' }}>Page 1 / 1</div>
        </div>
      </div>
    </div>
  );
};

export default PrintReport;
